import React from 'react';
import { Link } from 'react-router-dom';

const About: React.FC = () => (
  <div className="section">
    <div className="wrap">
      <div className="measure" style={{ margin: '0 auto' }}>
        <span className="eyebrow" style={{ display: 'block', marginBottom: 10 }}>
          About
        </span>
        <h1 style={{ fontSize: 32, marginBottom: 20 }}>About Common Room</h1>

        <p style={{ lineHeight: 1.7, marginBottom: 16 }}>
          Colleges don't admit potential — they admit proof. And in a world filled with
          straight-A students, test prep, and identical extracurriculars, the most powerful way
          for a teen to stand out is to build something real.
        </p>
        <p style={{ lineHeight: 1.7, marginBottom: 16 }}>
          Common Room connects families with mentors who have already walked the path — students
          and parents whose records are verified against official sources, not testimonials.
          Every mentor shares exactly what they did, what it cost, and what came of it.
        </p>

        <h2 style={{ fontSize: 22, margin: '32px 0 14px' }}>Why we built this</h2>
        <p style={{ lineHeight: 1.7, marginBottom: 16 }}>
          Common Room was created by parents and activity coaches who have helped many students
          reach top universities — not just through grades, but through character-building,
          passion-driven work that changed who those students became. We kept seeing the same
          problem:
        </p>
        <ul style={{ paddingLeft: 20, marginBottom: 16 }}>
          <li style={{ lineHeight: 1.7, marginBottom: 8 }}>
            Students with perfect resumes, but nothing that made them unique
          </li>
          <li style={{ lineHeight: 1.7, marginBottom: 8 }}>
            Teens learning skills, but never applying them
          </li>
          <li style={{ lineHeight: 1.7, marginBottom: 8 }}>
            Families paying for advice from people who never did the thing themselves
          </li>
        </ul>
        <p style={{ lineHeight: 1.7, marginBottom: 16 }}>
          Verified experience changes that. When families learn from someone who actually
          navigated the same competition, the same applications, and the same trade-offs, they
          get judgment — not generic advice.
        </p>
        <p style={{ lineHeight: 1.7, marginBottom: 16 }}>
          This is bigger than admissions. It's identity formation. It's confidence. It's purpose.
          Common Room exists to give every family that access — not just the few with private
          consultants.
        </p>

        <div className="card warm" style={{ marginTop: 32, padding: 28, textAlign: 'center' }}>
          <p style={{ fontWeight: 500, marginBottom: 16 }}>
            Start with a mentor who's actually done it.
          </p>
          <Link className="btn btn-primary" to="/mentors">
            Browse mentors
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default About;
